var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFcbk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 27,
    viewBox: "0 0 98 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8703 1.4082H13.2144V4.06413H15.8703V1.4082Z",
    fill: "#EB1E23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9162 1.76465H8.97559V3.70522H10.9162V1.76465Z",
    fill: "#EB1E23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8703 17.4453H13.2144V20.1012H15.8703V17.4453Z",
    fill: "#73BE55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9162 17.8037H8.97559V19.7443H10.9162V17.8037Z",
    fill: "#73BE55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0197 9.01953H21.6436V12.4923H30.0197V9.01953Z",
    fill: "#2DAAE1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6436 0.643555H18.1709V9.01975H21.6436V0.643555Z",
    fill: "#EB1E23"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6436 12.4922H18.1709V20.8684H21.6436V12.4922Z",
    fill: "#73BE55"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1687 9.01953H9.79248V12.4923H18.1687V9.01953Z",
    fill: "#FFC805"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49578 9.42871H4.83984V12.0846H7.49578V9.42871Z",
    fill: "#FFC805"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.53969 9.78418H0.599121V11.7247H2.53969V9.78418Z",
    fill: "#FFC805"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6263 9.02035H39.8763V5.54761C39.8763 4.67877 40.3861 4.16891 41.255 4.16891H44.6263V0.594727H40.7451C37.8343 0.594727 36.1486 2.3324 36.1486 5.19123V9.02295H33.4927V12.4957H36.1486V26.2358H39.8763V12.4931H44.6263V9.02035Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2075 23.0639C50.2446 23.0639 48.3561 21.0713 48.3561 17.752C48.3561 14.1258 50.3981 12.2373 53.2075 12.2373C55.403 12.2373 57.0887 13.361 57.2942 15.3536H60.9724C60.7669 11.1135 57.1407 8.66309 53.2101 8.66309C48.8685 8.66309 44.6284 11.7794 44.6284 17.7546C44.6284 23.272 48.2026 26.5913 53.2101 26.5913C57.1433 26.5913 60.7175 24.4972 61.0765 20.4106H57.3982C57.1381 22.1951 55.1975 23.0639 53.2075 23.0639Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6152 8.66104C70.0113 8.66104 67.2019 10.0397 66.281 11.7774L66.3824 10.7057V0.591797H62.6548V26.2302H66.6374L66.3304 23.5223C67.7091 25.6163 69.6497 26.5866 72.4071 26.5866C77.3105 26.5866 80.5804 22.7549 80.5804 17.5965C80.583 12.4407 77.2117 8.66104 72.6152 8.66104ZM71.5408 23.0645C68.578 23.0645 66.3824 20.8689 66.3824 17.9061V17.5991C66.3824 14.4333 68.578 12.2352 71.6943 12.2352C74.6572 12.2352 76.9047 14.5348 76.9047 17.5471C76.9047 20.8169 74.7092 23.0645 71.5408 23.0645Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1469 15.7938L97.5918 9.02002H92.7404L86.0993 15.0915V0.591797H82.3716V26.2302H86.0993V19.4773L87.5508 18.1558L93.4531 26.2302H98.0002L90.1469 15.7938Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFcbk);
export default __webpack_public_path__ + "static/media/fcbk.5050750c8ade65aa930e79336c6d4094.svg";
export { ForwardRef as ReactComponent };